module.exports = __webpack_public_path__ + "static/media/covidstories_cover5.d5264269.png";